import styled from '@emotion/styled';
import theme, { toRgba } from '../../theme';

export const Overlay = styled.div({
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',

  '.container': {
    height: '100%',
  },

  '.row': {
    height: '100%',
  },
  '.col': {
    height: '100%',
    display: 'flex',
  },
});

export const Container = styled.div({
  margin: 'auto',
  [`@media ${theme.breakpoints.above.small}`]: {

  },
});

export const Dialog = styled.div({
  display: 'flex',
  position: 'relative',
  flexDirection: 'column',
  alignSelf: 'center',
  width: '100%',
  maxHeight: '92vh',
  padding: '1rem 0.625rem 0.625rem',
  margin: '0 0.625rem',
  boxSizing: 'border-box',
  backgroundColor: theme.colors.lightBlue,
  [`@media ${theme.breakpoints.above.small}`]: {
    paddingTop: '1.5rem',
    maxHeight: '80vh',
  },
});

export const ScrollContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  overflow: 'auto',
  minHeight: 0,
});

export const Content = styled.div({
  backgroundColor: theme.colors.light,
  padding: '0.8rem',
  [`@media ${theme.breakpoints.above.small}`]: {
    padding: '0.8rem 2.5rem',
  },
});

export const Headline = styled.h3({
  margin: 0,
  paddingLeft: '0.625rem',
  paddingBottom: '1rem',
  [`@media ${theme.breakpoints.above.small}`]: {
    paddingBottom: '1.5rem',
  },
  color: theme.colors.light,
  fontWeight: 'bold',
  fontSize: '1.25rem',
  lineHeight: '1.6875rem',
  paddingRight: 48,
});

export const CloseIconWrapper = styled.div({
  position: 'absolute',
  top: 0,
  right: 0,
});

export const CloseIconButton = styled.button({
  width: 43,
  height: 43,
  background: 'none transparent',
  backgroundColor: theme.colors.darkBlue,
  borderRadius: 0,
  border: 'none',
  cursor: 'pointer',
  '&:hover': {
    '& svg path': {
      fill: theme.colors.grey,
    },
  },
});

export const overlay = {
  backgroundColor: toRgba(theme.colors.light, theme.opacities.overlay),
  zIndex: 100,
  height: '100%',
  width: '100%',
};

// we need to overwrite some defaults of the modal dialog here
export const content = {
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  padding: 0,
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  backgroundColor: 'transparent',
  border: 'none',
};
